var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVenuesBw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_33308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 37.3066C19.7353 33.3885 23.6516 30.7559 26.9359 27.6794C30.0525 24.7599 32 20.6074 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 20.6074 1.94745 24.7599 5.06412 27.6794C8.34841 30.7559 12.2647 33.3885 14.4783 37.3066L15.5647 39.2295C15.7561 39.5682 16.2439 39.5682 16.4353 39.2295L17.5217 37.3066Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13V11.7012L20 11.7012C21.1046 11.7012 22 10.8058 22 9.70119V8C22 6.89543 21.1046 6 20 6H17C15.8954 6 15 6.89543 15 8L15 13H11C9.34315 13 8 14.3431 8 16V23C8 24.6569 9.34315 26 11 26H13H15H17H19H21C22.6569 26 24 24.6569 24 23V16C24 14.3431 22.6569 13 21 13H17ZM20 9.70119L17 9.70119V8L20 8V9.70119ZM21 15H11C10.4477 15 10 15.4477 10 16V23C10 23.5523 10.4477 24 11 24H13V22C13 20.3431 14.3431 19 16 19C17.6569 19 19 20.3431 19 22V24H21C21.5523 24 22 23.5523 22 23V16C22 15.4477 21.5523 15 21 15ZM16 21C16.5523 21 17 21.4477 17 22V24H15V22C15 21.4477 15.4477 21 16 21Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_33308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 39.4835,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVenuesBw);
export default __webpack_public_path__ + "static/media/icon_venues_bw.bd98e9e4e4d2437c9998e9e5439780b0.svg";
export { ForwardRef as ReactComponent };